import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
    Avatar,
    Box,
    Button,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Paper,
    Typography,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import VideocamIcon from '@mui/icons-material/Videocam';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import LogoutIcon from '@mui/icons-material/Logout';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { useNavigate } from 'react-router-dom';

import {
    logoutCustomer,
    deleteCustomerAccount,
} from '../actions/customerActions';

const Account = ({ customer, logoutCustomer, deleteCustomerAccount }) => {
    const navigate = useNavigate();
    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);

    const handleLogout = async () => {
        await logoutCustomer();
        navigate('/home');
    };

    const handleDelete = async () => {
        setConfirmDeleteOpen(false);
        await deleteCustomerAccount();
        navigate('/home');
    };

    return (
        <Container maxWidth="sm" sx={{ py: 4 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <IconButton onClick={() => navigate('/home')}>
                    <ArrowBackIcon />
                </IconButton>
                <Typography variant="h5" component="h1">
                    Mi cuenta
                </Typography>
            </Box>
            <Paper elevation={3} sx={{ p: 4 }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        mb: 3,
                    }}
                >
                    <Avatar
                        src={customer.profileImageUrl || undefined}
                        imgProps={{ referrerPolicy: 'no-referrer' }}
                        sx={{ width: 72, height: 72, mb: 2 }}
                    >
                        {customer.name ? customer.name[0] : '?'}
                    </Avatar>
                    <Typography variant="h5">
                        {[customer.name, customer.lastName]
                            .filter(Boolean)
                            .join(' ') || 'Mi cuenta'}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {customer.email}
                    </Typography>
                </Box>

                <Divider sx={{ mb: 1 }} />

                <List>
                    <ListItemButton onClick={() => navigate('/account/calls')}>
                        <ListItemIcon>
                            <VideocamIcon />
                        </ListItemIcon>
                        <ListItemText primary="Mis videollamadas" />
                    </ListItemButton>
                    <ListItemButton onClick={() => navigate('/account/orders')}>
                        <ListItemIcon>
                            <ReceiptLongIcon />
                        </ListItemIcon>
                        <ListItemText primary="Mis órdenes de compra" />
                    </ListItemButton>
                    <ListItemButton onClick={handleLogout}>
                        <ListItemIcon>
                            <LogoutIcon />
                        </ListItemIcon>
                        <ListItemText primary="Cerrar sesión" />
                    </ListItemButton>
                    <ListItemButton onClick={() => setConfirmDeleteOpen(true)}>
                        <ListItemIcon>
                            <DeleteForeverIcon color="error" />
                        </ListItemIcon>
                        <ListItemText
                            primary="Eliminar cuenta"
                            primaryTypographyProps={{ color: 'error' }}
                        />
                    </ListItemButton>
                </List>
            </Paper>

            <Dialog
                open={confirmDeleteOpen}
                onClose={() => setConfirmDeleteOpen(false)}
            >
                <DialogTitle>¿Eliminar tu cuenta?</DialogTitle>
                <DialogContent>
                    <Typography>
                        Se van a cerrar todas tus sesiones y se va a borrar tu
                        perfil. Esta acción no se puede deshacer.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setConfirmDeleteOpen(false)}>
                        Cancelar
                    </Button>
                    <Button
                        color="error"
                        variant="contained"
                        onClick={handleDelete}
                    >
                        Eliminar cuenta
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
};

const mapStateToProps = (state) => {
    return {
        customer: state.customer.customer,
    };
};

export default connect(mapStateToProps, {
    logoutCustomer,
    deleteCustomerAccount,
})(Account);
